import React from 'react';
import {
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import {
  setLanguageCookie,
  SUPPORTED_LANGUAGES,
  SupportedLanguage,
} from 'translations/translations';

const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  en: 'English',
  da: 'Dansk',
  de: 'Deutsch',
  pl: 'Polski',
};

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '11.8rem',
    marginBottom: theme.spacing(1),
  },
  select: {
    color: 'white',
    '&:before': {
      borderColor: 'rgba(255, 255, 255, 0.5)',
    },
    '&:after': {
      borderColor: 'white',
    },
    '&:hover:not(.Mui-disabled):before': {
      borderColor: 'white',
    },
  },
  label: {
    color: 'rgba(255, 255, 255, 0.7)',
    '&.Mui-focused': {
      color: 'white',
    },
  },
  icon: {
    color: 'white',
  },
}));

const LanguageSwitcher: React.FC = () => {
  const { t, i18n } = useTranslation(['translations']);
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const lang = event.target.value as SupportedLanguage;
    setLanguageCookie(lang);
  };

  const currentLanguage = (SUPPORTED_LANGUAGES as readonly string[]).includes(
    i18n.language,
  )
    ? (i18n.language as SupportedLanguage)
    : 'en';

  return (
    <FormControl className={classes.formControl}>
      <InputLabel className={classes.label}>
        {t('language_switcher.label')}
      </InputLabel>
      <Select
        value={currentLanguage}
        onChange={handleChange}
        className={classes.select}
        inputProps={{ classes: { icon: classes.icon } }}
      >
        {SUPPORTED_LANGUAGES.map((lang) => (
          <MenuItem key={lang} value={lang}>
            {LANGUAGE_LABELS[lang]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export { LanguageSwitcher };
